<template>
	<v-app-bar
		app
		color="white"
		dark
		flat
		height="60"
		class="primary--text"
		:class="$vuetify.rtl ? 'rounded-tr-large': ' rounded-tl-large'"
	>
		<!-- drawer button -->
		<template v-if="$vuetify.breakpoint.smAndDown">
			<v-btn
				icon
				color="primary"
				@click="$emit('update-drawer')"
			>
				<v-icon>mdi-menu</v-icon>
			</v-btn>
		</template>

		<span :class="$vuetify.breakpoint.mdAndUp ? 'text-h6 ms-4' : 'text-body-1 ms-1'">
			{{currentRouteName}}
		</span>
		<v-spacer/>
		
		<!-- user -->
		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					color="primary"
					text
					:small="$vuetify.breakpoint.smAndDown"
					v-on="on"
					v-bind="attrs"
				>
					<v-icon size="22">mdi-account</v-icon>
					<span class="mx-2">{{user.FullName}}</span>
					<v-icon size="22">mdi-chevron-down</v-icon>
				</v-btn>
			</template>

			<v-list nav dense>
				<v-list-item @click="logout">
					<v-list-item-icon class="me-2"><v-icon>mdi-logout</v-icon></v-list-item-icon>
					<v-list-item-title>{{$t('Navbar.logout')}}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import routes from '@/router/routes'
import { mapState } from 'vuex';
export default {
	name: 'Navbar',

	computed: {
		...mapState({
			user: state => state.auth.user,
		}),

		currentRouteName() {
			const currentRoute = routes.find(c => c.name === this.$route.name);
			return this.$t(`routes.${currentRoute.i18nTitleKey}`)
		}
	},

	methods: {
		logout() {
			this.$store.dispatch('auth/logout');
			this.$store.dispatch('reset');
			this.$router.replace({ name: 'login' });
		}
	}
}
</script>

<style>

</style>